// src/features/Branches/getBranchServerSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiDatabase } from "../../App/API/api"; 

export const fetchBranchServer = createAsyncThunk(
    "branchServer/fetchData",
    async (_, thunkAPI) => {
        try {
            const response = await apiDatabase.get("/global-branch");
            console.log(response)
            if (response.status == 200) {
                return response.data;
            } else {
                console.error("Unexpected response structure:", response.data);
                return thunkAPI.rejectWithValue({
                    status: response.data?.status || "error",
                    message: "Unexpected response structure",
                });
            }
        } catch (err) {
            const statusCode = err.response?.status ?? 500;
            const message =
                err.response?.data?.message ?? err.message ?? "Unknown error";
            return thunkAPI.rejectWithValue({ statusCode, message });
        }
    }
);

const branchServerSlice = createSlice({
    name: "branchServer",
    initialState: {
        loading: false,
        error: null,
        branches: [],
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBranchServer.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchBranchServer.fulfilled, (state, action) => {
                state.loading = false;
                state.branches = action.payload;
            })
            .addCase(fetchBranchServer.rejected, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.error = action.payload;
                } else {
                    state.error = { statusCode: 500, message: action.error.message };
                }
            });
    },
});

export default branchServerSlice.reducer;
